"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyArchivedTab = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsSpots = require("@olxbr/ds-spots");
var _ScreenPlaceholder = require("../../molecules/ScreenPlaceholder");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var EmptyArchivedTab = exports.EmptyArchivedTab = function EmptyArchivedTab() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenPlaceholder.ScreenPlaceholder, {
    spot: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsSpots.Chat, {}),
    title: "Voc\xEA n\xE3o tem mensagens arquivadas",
    text: "Assim que uma mensagem for arquivada, voc\xEA poder\xE1 v\xEA-la nessa aba."
  });
};